import casApiClient from '@/plugins/cas-api-client';
export default (function () {
    casApiClient.interceptors.request.use(function (config) {
        if (!config.headers.Authorization && process.env.casApiKeyId && process.env.casApiSecretKey) {
            config.headers.Authorization = "Bearer " + process.env.casApiKeyId + ":" + process.env.casApiSecretKey;
        }
        return config;
    }, function (err) { return Promise.reject(err); });
});
